import React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@omni/components/utils/authorisation/authorisation.provider"
    ).then((module) => ({
        default: module.AuthorisationProvider
    }))
);
